<template>
    <v-col cols="12" lg="4" md="6" sm="12">
      <v-card dense :loading="loading">
        <v-card-title class="mx-0 mt-0 mb-2 px-0 pb-0 pt-1 border-top-purple">
                <Link :href="baseurl+'/event/'+event.alias" class="px-5 py-5">
                  {{ event.title }}
                </Link>
        </v-card-title>
            <v-card-text>
                <v-img :src="baseurl + '/img/' + event.photo_path"></v-img>
            </v-card-text>
            <v-card-actions>
                <v-row>
                                    <v-col cols="12" md="10" sm="12" class="bottom-border-purple">
                                        <span class="text-h5">Event Details</span>
                                    </v-col>
                                    <v-col lg="6" md="12" v-if="event.start_date">
                                        <span class="text-lg-h6">Date <v-icon>mdi-calendar</v-icon></span>
                                        <p><span>{{ prettyDate(event.start_date) }}</span><span v-if="event.end_date && event.end_date != event.start_date"> - {{ prettyDate(event.end_date) }}</span></p>
                                    </v-col>
                                    <v-col lg="6" md="12" v-if="event.start_time">
                                        <span class="text-lg-h6">Time <v-icon>mdi-clock</v-icon></span>
                                        <p><span>{{ prettyTime(event.start_time) }}</span><span v-if="event.end_time"> - {{ prettyTime(event.end_time) }}</span></p>
                                    </v-col>
                                    
                                    <v-col lg="6"  md="12" v-if="event.location=='In-person'">
                                        <span class="text-lg-h6">Location <a :href="getUrl()" target="_blank"><v-icon>mdi-map</v-icon></a></span>
                                        <p><span v-if="event.address">{{ event.address }}</span>&nbsp;<span v-if="event.city">{{ event.city }}</span>&nbsp;<span v-if="event.postal_code">{{ event.postal_code }}</span>&nbsp;{{event.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                                    </v-col>
                                    <v-col lg="6"  md="12" v-if="event.location=='Online'">
                                        <span class="text-lg-h6">{{event.event_link_description}}</span>
                                        <p>A link to the event will be emailed to you.</p>
                                    </v-col>
                                    <v-col lg="6"  md="12">
                                        <Link :href="baseurl+'/event/'+event.alias">
                                            <v-btn>Event Details</v-btn>
                                        </Link>
                                    </v-col>
                                </v-row>
            </v-card-actions>
            
  
      </v-card>   
    </v-col>
  </template>
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'
  
  import { Link } from '@inertiajs/inertia-vue'
  
  export default {
    props: {
      event: Object,
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
    },
    components: {
      Head,
      Link
    },
    layout: Layout,
    data() {
        return {
            loading:false
        }
    },
    watch: {
    },
    created() {
    },
    methods: {  
        prettyDate(x) {
            var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            return new Date(x).toLocaleDateString(undefined,options)
        },
        prettyTime(x) {
            return x.slice(0, -3).replace(/^[0]/g,"");
        },
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>